import publicDriverFactory from './ColorPicker.uni.driver';
import userEvent from '@testing-library/user-event';
import { ReactBase } from '../utils/test-utils/unidriver';
import { DataHooks } from './constants';

export const colorPickerUniDriverFactory = base => ({
  ...publicDriverFactory(base),

  selectBlackColor: async () => {
    const baseEl = await base.$(`[data-hook="${DataHooks.hsb}"]`).getNative();
    return userEvent.pointer({
      keys: '[MouseLeft]',
      target: baseEl,
      coords: {
        clientX: 1,
        clientY: 1,
      },
    });
  },

  clickCancelButton: () =>
    base.$('[data-hook="color-picker-cancel-button"]').click(),
});
